import AppSettings from "../storage/appSettings";

/**
 * @fileoverview Utility functions for making GET and POST requests.
 * This module provides helper functions to interact with APIs.
 */

/**
 * Performs a GET request to the specified URL.
 * @async
 * @function getQuery
 * @param {string} url - The API endpoint to fetch data from.
 * @returns {Promise<{response: number, data?: any, error?: any}>}
 * An object containing the response status and either the data or an error message.
 */
export const getQuery = async (url) => {
  try {
    const response = await fetch(url);

    if (!response.ok) {
      console.log(`HTTP error! status: ${response.status}`);
      return { response: 400 };
    }

    const data = await response.json();
    AppSettings.setState({ connectionError: false });

    return {
      response: 200,
      data: data,
    };
  } catch (error) {
    console.log("Error fetching data:", error);
    AppSettings.setState({ connectionError: true });
    return { response: 400 };
  }
};

/**
 * Performs a POST request to execute a GraphQL query.
 * @async
 * @function postQuery
 * @param {string} url - The GraphQL endpoint to send the request to.
 * @param {string} query - The GraphQL query string.
 * @param {Object} [variables={}] - Optional variables for the GraphQL query.
 * @returns {Promise<{response: number, data?: any, error?: any}>}
 * An object containing the response status, fetched data (if successful), or an error message.
 */
export const postQuery = async (url, query, variables = {}) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_API_KEY,
      },
      body: JSON.stringify({ query, variables }),
    });

    if (!response.ok) {
      console.error(`HTTP error! status: ${response.status}`);
      return { response: response.status, error: await response.text() };
    }

    const data = await response.json();
    AppSettings.setState({ connectionError: false });
    return { response: 200, data: data.data };
  } catch (error) {
    console.error("Error in postQuery:", error);
    AppSettings.setState({ connectionError: true });
    return { response: 400, error };
  }
};
